import React, { Component } from 'react';
import {Helmet} from 'react-helmet';

import '../App.css';

class About extends Component {

  render() {
    return (
        <div className="page about" id="page">
          <Helmet>
            <title>rewardeclub | How does it work?</title>
            <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            <meta name="description" content="rewardeclub easily creates & manages customers eclub." />
            <meta name="keywords" content="eclub, e-club, customer eclub, customer e-club, customers eclub, customers e-club, manage eclub, eclub management, manage e-club, e-club management, connect business and customers" />
            <meta name="robots" content="index, follow" />
          </Helmet>
          <div className="howitworks-0"></div>
          <div className="howitworks-1">1</div>
          <div className="howitworks-2">2</div>
          <div className="howitworks-3">3</div>
          <div className="howitworks-4">4</div>
          <div className="howitworks-5">5</div>
        </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/page/About.js